import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

async function exportToExcel(data, filename, columnFormats = {}, headers) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(filename);

    const borderColor = { argb: "FF000000" };
    const dataKeys = data.length > 0 ? Object.keys(data[0]) : [];

    worksheet.columns = dataKeys.map((key, index) => {
        const format = columnFormats[key] || {}; 
        return {
            header: format.header || headers[index] || key,
            key,
            width: format.width || 15,
        };
    });

    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: "FF000000" }, name: "Calibri", size: 11 };
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFB8CCE4" },
        };
        cell.alignment = {
            vertical: "middle",
            horizontal: "center",
            wrapText: true,
        };
        cell.border = {
            top: { style: "thin", color: borderColor },
            left: { style: "thin", color: borderColor },
            bottom: { style: "thin", color: borderColor },
            right: { style: "thin", color: borderColor },
        };
    });
    headerRow.height = 30;

    data.forEach((item) => worksheet.addRow(item));


    var columnFormatsFiltered = Object.fromEntries(
        Object.entries(columnFormats).filter(([key]) => dataKeys.includes(key))
    );

    worksheet.eachRow((row, rowIndex) => {
        if (rowIndex === 1) return; // skip header

        dataKeys.forEach((key, colIndex) => {
            const cell = row.getCell(colIndex + 1);
            const format = columnFormatsFiltered[key] || {};

            let alignment = { vertical: "middle", horizontal: "center" };

            if (format.align) alignment.horizontal = format.align;
            if (format.wrap) alignment.wrapText = true;

            if (format.type === "accounting") {
                cell.numFmt = '_($* #,##0.00_);_($* (#,##0.00);_($* "-"??_);_(@_)';
            } else if (format.type === "number" && format.numFmt) {
                cell.numFmt = format.numFmt;
            }

            if (format.fill) {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: format.fill.replace("#", "FF") },
                };
            }

            if (format.font) {
                const f = format.font;
                cell.font = {
                    bold: f.bold ?? false,
                    italic: f.italic ?? false,
                    size: f.size ?? 10,
                    name: f.name ?? "Calibri",
                    color: f.color ? { argb: f.color.replace("#", "FF") } : undefined,
                };
            }

            cell.alignment = alignment;

            cell.border = {
                top: { style: "thin", color: borderColor },
                left: { style: "thin", color: borderColor },
                bottom: { style: "thin", color: borderColor },
                right: { style: "thin", color: borderColor },
            };
        });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), filename.replace(/\s+/g, "_") + ".xlsx");
}

export { exportToExcel };
